import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
import "./Login.css";

const Login = () => {
  const [registrationNumber, setregistrationNumber] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const redirectPath = new URLSearchParams(location.search).get("redirect");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // ✅ Static Court Login Check
    if (registrationNumber === "9876543210" && password === "123") {
      console.log("Static court login successful");
      localStorage.setItem("userRole", "court");
      localStorage.setItem("normalizedUserRole", "court");
      localStorage.setItem("Token", "static-court-token");
      localStorage.setItem("token", "static-court-token");
      localStorage.setItem(
        "user",
        JSON.stringify({ registrationNumber: "9876543210", role: "court" })
      );

      setTimeout(() => {
        navigate("/Individualcourtscreen", { replace: true });
      }, 100);
      setLoading(false);
      return;
    }

    // ✅ Static Livescore Login Check
    if (registrationNumber === "5555555555" && password === "123") {
      console.log("Static livescore login successful");
      localStorage.setItem("userRole", "court");
      localStorage.setItem("normalizedUserRole", "court");
      localStorage.setItem("Token", "static-court-token");
      localStorage.setItem("token", "static-court-token");
      localStorage.setItem(
        "user",
        JSON.stringify({ registrationNumber: "5555555555", role: "court" })
      );

      setTimeout(() => {
        navigate("/court", { replace: true });
      }, 100);
      setLoading(false);
      return;
    }

    // Updated API endpoint
    const loginApiEndpoint = "https://api.asterickx.com/api/Auth/login";

    try {
      console.log("Attempting login with phone number:", registrationNumber);

      const response = await fetch(loginApiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          registrationNumber: registrationNumber,
          password: password,
        }),
      });

      const data = await response.json();
      console.log("Login response:", data);

      if (response.ok) {
        console.log("Login successful - Full response:", data);

        // ✅ Extract token from response
        const tokenString = data.token;

        if (!tokenString) {
          console.warn("⚠️ No token found in response");
          await Swal.fire({
            icon: 'warning',
            title: 'Authentication Issue',
            text: 'Login successful but no authentication token received. Please contact support.',
            confirmButtonColor: '#000'
          });
          setLoading(false);
          return;
        }

        // Store token in multiple formats for compatibility
        localStorage.setItem("Token", tokenString);
        localStorage.setItem("token", tokenString);
        localStorage.setItem("authToken", tokenString);
        console.log("Token stored in localStorage");

        // ✅ Extract role from roles array
        const userRole = data.roles && data.roles.length > 0 ? data.roles[0] : "user";
        console.log("User role extracted:", userRole);

        // Store user data
        const userData = {
          mobileNumber: data.mobileNumber,
          fullName: data.fullName,
          roles: data.roles,
          userRole: userRole
        };
        localStorage.setItem("user", JSON.stringify(userData));
        console.log("User data stored:", userData);

        // Normalize and store role
        const normalizedRole = userRole.toLowerCase().trim();
        console.log("Normalized user role:", normalizedRole);

        localStorage.setItem("userRole", userRole);
        localStorage.setItem("normalizedUserRole", normalizedRole);

        console.log("✅ All data stored in localStorage:");
        console.log("- Token:", localStorage.getItem("Token"));
        console.log("- User:", localStorage.getItem("user"));
        console.log("- User Role:", localStorage.getItem("userRole"));
        console.log("- Normalized Role:", localStorage.getItem("normalizedUserRole"));

        // Determine redirect path
        let finalRedirectPath;

        // Route based on role
        if (normalizedRole === "admin") {
          finalRedirectPath = "/AdminDashboard";
          console.log("Admin role detected - redirecting to AdminDashboard");
        } else if (normalizedRole === "plyr") {
          finalRedirectPath = "/profile";
          console.log("Player role detected - redirecting to profile");
        } else if (normalizedRole.includes("umpire") || normalizedRole.includes("umpr")) {
          // finalRedirectPath = "/listofgame";
          finalRedirectPath = "/score-entry"
          console.log("Umpire role detected - redirecting to listofgame");
        } else if (normalizedRole === "vndr") {
          finalRedirectPath = "/vendor-scanner";
          console.log("Court role detected - redirecting to court screen");
        } else {
          console.warn("Unknown user role:", userRole);
          finalRedirectPath = "/profile";
          console.log("Using default redirect to dashboard");
        }

        console.log("Final redirect path:", finalRedirectPath);

        // Show success message with auto redirect
        Swal.fire({
          icon: 'success',
          title: 'Welcome!',
          text: 'Login successful! Redirecting...',
          confirmButtonColor: '#000',
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(() => {
          // Navigate after SweetAlert closes
          navigate(finalRedirectPath, { replace: true });
        });
      } else {
        console.error("Login failed - API returned error");
        console.error("Error data:", data);
        await Swal.fire({
          icon: 'error',
          title: 'Login Failed',
          text: data.message || data.title || data.error || "Login failed. Please check your credentials.",
          confirmButtonColor: '#000'
        });
      }
    } catch (error) {
      console.error("Login error - Network or other issue:", error);
      await Swal.fire({
        icon: 'error',
        title: 'Connection Error',
        text: 'Unable to connect to the server. Please check your internet connection and try again.',
        confirmButtonColor: '#000'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterClick = () => {
    navigate("/Userreg");
  };

  return (
    <div className="login-container">
      {/* Animated Background Elements */}
      <div className="background-animations">
        {/* Animated Rackets */}
        <div className="badminton-element racket-1">
          <svg width="100" height="100" viewBox="0 0 100 100">
            <ellipse
              cx="50"
              cy="35"
              rx="28"
              ry="32"
              // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="4"
              fill="none"
            />
            <line
              x1="46"
              y1="22"
              x2="46"
              y2="48"
              // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <line
              x1="50"
              y1="22"
              x2="50"
              y2="48"
             // stroke="#000000ff"
             stroke="#FFD700"
              strokeWidth="2"
            />
            <line
              x1="54"
              y1="22"
              x2="54"
              y2="48"
              // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <line
              x1="32"
              y1="30"
              x2="68"
              y2="30"
             // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <line
              x1="32"
              y1="35"
              x2="68"
              y2="35"
              // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <line
              x1="32"
              y1="40"
              x2="68"
              y2="40"
             // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <rect x="46" y="67" width="8" height="30" rx="4" fill="#000000ff" />
          </svg>
        </div>

        <div className="badminton-element racket-2">
          <svg width="90" height="90" viewBox="0 0 100 100">
            <ellipse
              cx="50"
              cy="35"
              rx="28"
              ry="32"
             // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="4"
              fill="none"
            />
            <line
              x1="46"
              y1="22"
              x2="46"
              y2="48"
             // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <line
              x1="50"
              y1="22"
              x2="50"
              y2="48"
              // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <line
              x1="54"
              y1="22"
              x2="54"
              y2="48"
              // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <line
              x1="32"
              y1="30"
              x2="68"
              y2="30"
              // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <line
              x1="32"
              y1="35"
              x2="68"
              y2="35"
              // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <line
              x1="32"
              y1="40"
              x2="68"
              y2="40"
              // stroke="#000000ff"
              stroke="#FFD700"
              strokeWidth="2"
            />
            <rect x="46" y="67" width="8" height="30" rx="4" fill="#000000ff" />
          </svg>
        </div>

        {/* Court Lines */}
        <div className="court-lines">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 800 128"
            preserveAspectRatio="none"
          >
            <line x1="0" y1="64" x2="800" y2="64" stroke="##000000ff" strokeWidth="4" />
            <line x1="200" y1="0" x2="200" y2="128" stroke="##000000ff" strokeWidth="2" />
            <line x1="400" y1="0" x2="400" y2="128" stroke="##000000ff" strokeWidth="4" />
            <line x1="600" y1="0" x2="600" y2="128" stroke="##000000ff" strokeWidth="2" />
          </svg>
        </div>
      </div>

      {/* Login Card */}
      <div className="login-card">
        <div className="login-header">
          <div className="header-background">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 100 100"
              className="net-pattern"
            >
              <pattern
                id="net"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  width="20"
                  height="20"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="0.5"
                />
              </pattern>
              <rect width="100" height="100" fill="url(#net)" />
            </svg>
          </div>

          <div className="header-content">
            <div className="login-icon">
              <svg width="48" height="48" viewBox="0 0 100 100">
                <ellipse
                  cx="50"
                  cy="40"
                  rx="24"
                  ry="28"
                 // stroke="#000000ff"
              stroke="#FFD700"
                  strokeWidth="5"
                  fill="none"
                />
                <line
                  x1="45"
                  y1="28"
                  x2="45"
                  y2="52"
                  // stroke="#000000ff"
              stroke="#FFD700"
                  strokeWidth="2"
                />
                <line
                  x1="50"
                  y1="28"
                  x2="50"
                  y2="52"
                  // stroke="#000000ff"
              stroke="#FFD700"
                  strokeWidth="2"
                />
                <line
                  x1="55"
                  y1="28"
                  x2="55"
                  y2="52"
                 // stroke="#000000ff"
              stroke="#FFD700"
                  strokeWidth="2"
                />
                <line
                  x1="34"
                  y1="36"
                  x2="66"
                  y2="36"
                  // stroke="#000000ff"
              stroke="#FFD700"
                  strokeWidth="2"
                />
                <line
                  x1="34"
                  y1="40"
                  x2="66"
                  y2="40"
                 // stroke="#000000ff"
              stroke="#FFD700"
                  strokeWidth="2"
                />
                <line
                  x1="34"
                  y1="44"
                  x2="66"
                  y2="44"
                  // stroke="#000000ff"
              stroke="#FFD700"
                  strokeWidth="2"
                />
                <rect
                  x="46"
                  y="68"
                  width="8"
                  height="28"
                  rx="4"
                  // stroke="#000000ff"
              fill="#FFD700"
                />
              </svg>
            </div>

            <h1>Login</h1>
            {/* <p>Access your profile</p> */}
          </div>
        </div>

        <div className="login-body">
          <form onSubmit={handleSubmit} className="login-form">
            {/* Phone Number Input */}
            <div className="form-group">
              <label htmlFor="registrationNumber">User ID</label>
              <div className="input-wrapper">
                <span className="input-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect
                      x="3"
                      y="3"
                      width="18"
                      height="18"
                      rx="2"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
                    <path
                      d="M7 17C7 14.8 9.2 13 12 13C14.8 13 17 14.8 17 17"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <input
                  type="tel"
                  id="registrationNumber"
                  placeholder="Enter your User ID"
                  value={registrationNumber}
                  onChange={(e) => setregistrationNumber(e.target.value)}
                  required
                  title="Please enter correct User ID"
                />
              </div>
            </div>

            {/* Password Input */}
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="input-wrapper">
                <span className="input-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect
                      x="3"
                      y="11"
                      width="18"
                      height="11"
                      rx="2"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="M7 11V7C7 4.79086 8.79086 3 11 3H13C15.2091 3 17 4.79086 17 7V11"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </svg>
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="3"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                      <line
                        x1="3"
                        y1="3"
                        x2="21"
                        y2="21"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Submit Button */}
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner"></span>
                  <span>Signing in...</span>
                </>
              ) : (
                <>
                  <span>Sign In</span>
                </>
              )}
            </button>
          </form>

          {/* Footer Badge */}
          {/* <div className="login-footer">
            <div className="footer-badge">
              <svg width="16" height="16" viewBox="0 0 100 100">
                <circle cx="50" cy="30" r="8" fill="currentColor" />
                <path
                  d="M50 38 L45 55 L38 75 M50 38 L50 55 L50 75 M50 38 L55 55 L62 75"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
              /*<span>Badminton Tournament System</span>*
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;